import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradingCompetitionKeys } from './tradingCompetition.keys';
import { unregisterFromTradingCompetition } from './tradingCompetition.service';
export const useUnregisterFromTradingCompetition = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ subdomain, tradingCompetitionId, }) => unregisterFromTradingCompetition(subdomain, tradingCompetitionId),
        onSuccess: async (_, { subdomain, tradingCompetitionId }) => {
            await queryClient.invalidateQueries({
                queryKey: tradingCompetitionKeys.isUserRegistered(subdomain, tradingCompetitionId),
            });
            // Invalidate all leaderboard queries for this competition
            await queryClient.invalidateQueries({
                queryKey: ['tradingCompetition', subdomain, 'leaderboard', tradingCompetitionId],
                exact: false,
            });
            // Invalidate all user rank queries for this competition
            await queryClient.invalidateQueries({
                queryKey: ['tradingCompetition', subdomain, 'userRank', tradingCompetitionId],
                exact: false,
            });
        },
    });
};
